import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENDPOINTS } from '../../endpoints/api-endpoints';
import { EMAIL_PASSWORD_LOGIN_PAYLOAD, OTP_LOGIN_PAYLOAD, PHONE_PASSWORD_LOGIN_PAYLOAD, SIGNUP_PAYLOAD, USER_DETAILS } from '../../types/types';

@Injectable({
  providedIn: 'root'
})
export class SamhitaOndcWoCService {

  constructor(private http:HttpClient) { }

  getUserDetails(){
    return this.http.get(ENDPOINTS.SAMHITA_ONDC.GET_USER_DETAILS).toPromise()
  }

  getUserDetailsNew(){
    return this.http.get(ENDPOINTS.SAMHITA_ONDC.GET_NEW_PROFILE).toPromise()
  }

  createProfileNew(data:any){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.CREATE_NEW_PROFILE,data)
  }

  updateProfileNew(data:any){
    return this.http.put(ENDPOINTS.SAMHITA_ONDC.UPDATE_NEW_PROFILE,data)
  }

  test(){}

  emailPasswordLogin(payload:EMAIL_PASSWORD_LOGIN_PAYLOAD){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.EMAIL_PASSWORD_LOGIN,payload)
  }

  phonePasswordLogin(payload:PHONE_PASSWORD_LOGIN_PAYLOAD){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.PHONE_PASSWORD_LOGIN,payload)
  }

  signUp(payload:SIGNUP_PAYLOAD){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.SIGNUP,payload)
  }

  OTPLogin(payload:OTP_LOGIN_PAYLOAD){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.OTP_LOGIN,payload)
  }

  requestOTP(payload:OTP_LOGIN_PAYLOAD){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.REQUEST_OTP,payload)
  }

  getS3SignedUrl(payload:any){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.GET_S3_SIGNED_URL,payload).toPromise()
  }

  getUserProfile(){
    return this.http.get(ENDPOINTS.SAMHITA_ONDC.USER_PROFILE)
  }

  createProfile(payload:USER_DETAILS){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.CREATE_PROFILE,payload)
  }

  updateProfile(payload:USER_DETAILS){
    return this.http.put(ENDPOINTS.SAMHITA_ONDC.USER_PROFILE,payload)
  }

  getOffNetworkJobs(){
    return this.http.get(ENDPOINTS.SAMHITA_ONDC.OFF_NETWORK_JOBS)
  }

  getOffNetworkJobDetails(id:string){
    return this.http.get(`${ENDPOINTS.SAMHITA_ONDC.OFF_NETWORK_JOBS}?job_id=${id}`)
  }

  getJobStatus(id:string){
    return this.http.get(`${ENDPOINTS.SAMHITA_ONDC.MY_OFF_NETWORK_JOBS}${id}/`)
  }

  applyForJob(id:string){
    return this.http.post(`${ENDPOINTS.SAMHITA_ONDC.APPLY_OFF_NETWORK_JOB}${id}/`,{})
  }

  getMyOffNetworkJobs(){
    return this.http.get(ENDPOINTS.SAMHITA_ONDC.MY_OFF_NETWORK_JOBS)
  }

  sendUniversalOtp(payload:{email?:string,phone?:string}){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.SEND_UNIVERSAL_OTP,payload)
  }

  verifyUniversalOtp(payload:{code:string,email?:string,phone?:string}){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.VERIFY_UNIVERSAL_OTP,payload)
  }

  ssoLogin(payload:{email?:string,phone?:string}){
    return this.http.post(ENDPOINTS.SAMHITA_ONDC.SSO_LOGIN,payload)
  }

  checkUserExistence(payload:{email?:string,phone?:string}){
    return this.http.post(`${ENDPOINTS.SAMHITA_ONDC.CHECK_USER_EXISTENCE}`,payload)
  }

  getAuth2Url(){
    return this.http.get(`${ENDPOINTS.SAMHITA_ONDC.AUTH_2_URL}`)
  }

  getOAuthTokenDetails(payload: { code: string; state: string }) {
    return this.http.post(`${ENDPOINTS.SAMHITA_ONDC.OAUTH_TOKEN_DETAILS}`, payload);
  }
  

}
